import api from './api';
import { QuizSubmission, QuizResult, QuizQuestionAPI } from '../types';

export const quizService = {
    /**
     * Fetch quiz questions for a specific course
     */
    getQuizQuestions: async (courseId: string): Promise<QuizQuestionAPI[]> => {
        const response = await api.get(`/courses/${courseId}/quiz/questions`);
        
        // Extract questions from the message field
        const questions = response.data.message || response.data;
        return questions;
    },

    /**
     * Submit quiz answers and get results
     */
    submitQuiz: async (courseId: string, submissions: QuizSubmission[]): Promise<QuizResult> => {
        const response = await api.post(`/courses/${courseId}/quiz/submit`, {
            submissions
        });
        
        // Extract result from the message field
        const result = response.data.message || response.data;
        return result;
    },

    /**
     * Get quiz attempt history for a course
     */
    getQuizHistory: async (courseId: string) => {
        const response = await api.get(`/courses/${courseId}/quiz/history`);
        return response.data;
    },

    /**
     * Check if user has passed the quiz for this course
     * Returns the latest quiz attempt status
     */
    getQuizCompletionStatus: async (courseId: string) => {
        const response = await api.get(`/courses/${courseId}/quiz/status`);
        return response.data;
    },

    /**
     * Get the latest quiz attempt for a course
     */
    getLatestQuizAttempt: async (courseId: string) => {
        const response = await api.get(`/courses/${courseId}/quiz/latest-attempt`);
        return response.data;
    }
};
